import {
  ApiBatchRequest,
  ApiListResponse,
  ApiRequest,
  ApiResponse,
} from "@interfaces/api";
import { API } from "aws-amplify";

type APIRequest = {
  response: true;
  body?: { [key: string]: any };
  queryStringParameters?: { [key: string]: any };
};

const API_NAME = "api";

export const getApiData = async (
  path: string,
  callFn: string,
  id: string,
  value?: string
): Promise<ApiResponse> => {
  const myInit = {
    queryStringParameters: {
      path,
      callFn,
      id,
      value,
    },
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  } as APIRequest;
  const res = await API.get(API_NAME, "api", myInit);
  return res as ApiResponse;
};

export const listApiData = async (
  path: string,
  callFn: string,
  id: string
): Promise<ApiListResponse> => {
  const myInit = {
    queryStringParameters: {
      path,
      callFn,
      id,
    },
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  } as APIRequest;
  const res = await API.get(API_NAME, "api", myInit);
  return res as ApiListResponse;
};

export const postApiData = async (
  path: string,
  callFn: string,
  requestData: ApiRequest
): Promise<ApiResponse> => {
  const myInit = {
    body: {
      path,
      callFn,
      ...requestData,
    },
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  } as APIRequest;
  const res = await API.post(API_NAME, "api", myInit);
  return res as ApiResponse;
};

export const postBatchApiData = async (
  path: string,
  callFn: string,
  requestData: ApiBatchRequest
): Promise<ApiResponse> => {
  const myInit = {
    body: {
      path,
      callFn,
      data: requestData,
    },
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  } as APIRequest;
  const res = await API.post(API_NAME, "api", myInit);
  return res as ApiResponse;
};

export const deleteBatchApiData = async (
  path: string,
  callFn: string,
  requestData: ApiBatchRequest
): Promise<ApiResponse> => {
  const myInit = {
    body: {
      path,
      callFn,
      data: requestData,
    },
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  } as APIRequest;
  const res = await API.del(API_NAME, "api", myInit);
  return res as ApiResponse;
};
